import React, { useState, useEffect, Fragment } from 'react';
import { useHistory, Link } from 'react-router-dom';
import Select from 'react-select';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, Button, CircularProgress
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CopyrightIcon from '@mui/icons-material/Copyright';
// Assume fetchData and postData are defined elsewhere
import { fetchData, updateData, postData } from '../../../apiService';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import PrintIcon from '@mui/icons-material/Print';
import { Box } from '@mui/material';
import QAPrint from './Print';
import ReactDOM from 'react-dom';
import Info from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import { generateQuotationPDF } from "./generateQuotationPDF";
import { generateRevisionQuotationPDF } from "./RevisionPDF";

const QuotationDetails = () => {
    const { id } = useParams();
    const history = useHistory();
    // const companyId = 2;
    // const userId = 1;
    const [isLoading, setIsLoading] = useState(false);
    const [groupedData, setGroupedData] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [formData, setFormData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedTCItems, setSelectedTCItems] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [loading, setLoading] = useState(false);
    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated]);

    // Date Format 
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const LoadTermsAndConditions = () => {
        if (!isModalGrpOpen) {

        }
        setIsModalGrpOpen(!isModalGrpOpen);
    };

    useEffect(() => {
        setLoading(true);
        fetchData('QuotationApi', `/Quotation/${id}`, token) //, token
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Quotation);
                    //setSelectedItems(response.response_data.QuotationDetails);
                    setSelectedItems(response.response_data.QuotationDetails || []);
                    setSelectedTCItems(response.response_data.QATermsAndCondition || [])
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));
                }
            })
            .catch((error) => {
                console.error('Error fetching Quotation Details:', error);
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    }, [id]);

    //const [groupedData, setGroupedData] = useState({});

    useEffect(() => {
        // Transform flat selectedItems to nested structure grouped by QAChildDetailName and WorkName
        const nested = {};

        selectedItems.forEach(item => {
            const qaName = item.QAChildDetailName || "Uncategorized";
            const workName = item.WorkName;

            if (!nested[qaName]) {
                nested[qaName] = {};
            }
            if (!nested[qaName][workName]) {
                nested[qaName][workName] = [];
            }

            nested[qaName][workName].push(item);
        });

        setGroupedData(nested);
    }, [selectedItems]);

    const [searchQuery, setSearchQuery] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const handleSearch = (event) => setSearchQuery(event.target.value);

    useEffect(() => {
        fetchTableData();
    }, []);

    const filteredGroupedDataByQA = Object.entries(groupedData).reduce((acc, [qaName, workGroups]) => {
        const filteredWorkGroups = {};

        Object.entries(workGroups).forEach(([workName, items]) => {
            // Filter items by search query
            const filteredItems = items.filter(item =>
                Object.values(item).some(val =>
                    String(val).toLowerCase().includes(searchQuery.toLowerCase())
                )
            );

            if (filteredItems.length > 0) {
                filteredWorkGroups[workName] = filteredItems;
            }
        });

        if (Object.keys(filteredWorkGroups).length > 0) {
            acc[qaName] = filteredWorkGroups;
        }

        return acc;
    }, {});

    const [expandedGroups, setExpandedGroups] = useState({});

    useEffect(() => {
        // Initialize expanded groups for nested structure (QA sections and Work groups)
        const initialExpanded = {};

        Object.entries(groupedData).forEach(([qaName, workGroups]) => {
            Object.keys(workGroups).forEach((workName) => {
                initialExpanded[`${qaName}-${workName}`] = true;
            });
        });

        setExpandedGroups(initialExpanded);
    }, [groupedData]);

    const toggleGroup = (key) => {
        setExpandedGroups(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    // Revision Details 
    const [revisionData, setRevisionData] = useState([]);
    const fetchTableData = async () => {
        setRevisionData([]);
        setLoading(true);
        fetchData('RevisionApi', `/QuotationRevision/${id}`, token) //, token
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setRevisionData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Quotation Revision Details:', error);
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    // Revision Modal
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    // Revision Print 
    const handlePrint = async (QaId) => {
        try {
            const response = await fetchData('QuotationApi', `/QAPrint/${QaId}`, token); //, token
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <QAPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();

            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing QA print :', error);
        }
    };

    const handleGenerate = async (QaId) => {
        try {
            const response = await fetchData('QuotationApi', `/QAPrint/${QaId}`, token);
            const labelData = response.response_data;

            if (labelData) {
                generateQuotationPDF(labelData);
            } else {
                console.error("No quotation data received.");
            }
        } catch (error) {
            console.error("Error generating quotation PDF:", error);
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    // ✅ Close modal
    const handleCloseModalTC = () => {
        setIsModalGrpOpen(false);
    };

    const handleGenerateRevision = async (QaId) => {
        try {
            const response = await fetchData('QuotationApi', `/QAPrint/${QaId}`, token);
            const labelData = response.response_data;

            if (labelData) {
                generateRevisionQuotationPDF(labelData);
            } else {
                console.error("No quotation data received.");
            }
        } catch (error) {
            console.error("Error generating quotation PDF:", error);
        }
    };

    return (
        <div
            style={{
                fontFamily: "Segoe UI, sans-serif",
                fontSize: "12px",
                width: "100%",
                padding: "5px",
                marginTop: '-15px'
            }}
        >
            {loading && (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(0,0,0,0.5)',
                        zIndex: 50,
                    }}
                >
                    {/* Inline Diamond Loader */}
                    <div
                        style={{
                            position: 'relative',
                            width: '50px',
                            height: '50px',
                            backgroundColor: 'rgba(255,255,255,0.1)',
                            transform: 'rotate(45deg)',
                            overflow: 'hidden',
                            borderRadius: '6px',
                            boxShadow: '0 6px 18px rgba(255,255,255,0.2)',
                        }}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                inset: '6px',
                                margin: 'auto',
                                background: '#ffffff',
                                borderRadius: '4px',
                            }}
                        ></div>
                        <div
                            style={{
                                position: 'absolute',
                                inset: '-12px',
                                margin: 'auto',
                                background: '#ff66cc',
                                borderRadius: '6px',
                                animation: 'diamondLoader 2s linear infinite',
                            }}
                        ></div>
                        <style>
                            {`
            @keyframes diamondLoader {
              0%,10% { transform: translate(-50px,-50px) rotate(-45deg); }
              90%,100% { transform: translate(0px,0px) rotate(-45deg); }
            }
          `}
                        </style>
                    </div>
                </div>
            )}

            {/* Header */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "6px",
                    marginBottom: "12px"
                }}
            >
                <h6 className="uppercase tracking-wide font-serif text-black mt-2">
                    Quotation Details
                </h6>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "300px repeat(3, 1fr)",
                        gap: "10px",
                        marginBottom: "12px",
                        alignItems: "end",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", width: "350px" }}>
                        {/* Label + Type */}
                        <label style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            marginRight: "8px",
                            whiteSpace: "nowrap",
                            color: 'red',
                            marginLeft: '-150px'
                        }}>
                            Customer
                            <span style={{ color: "black", marginLeft: "8px" }}>
                                (GST No: {formData?.GSTNumber || "-"})
                            </span>
                        </label>

                        {/* Input */}
                        <div style={{ flexGrow: 1 }}>
                            <input
                                type="text"
                                name="CustomerName"
                                value={formData.CustomerName}
                                disabled
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    fontSize: "12px",
                                    height: "28px",
                                    width: "100%",
                                    padding: "0 6px"
                                }}
                            />
                        </div>
                    </div>

                </div>

                <div className="flex items-center gap-3 mt-2 md:mt-0" style={{ flexShrink: 0 }}>

                    {/* Previous Revision */}
                    <Button
                        variant="contained"
                        onClick={toggleModal}
                        disabled={isLoading}
                        style={{
                            height: "25px",
                            minWidth: "80px",
                            borderRadius: "6px",
                            backgroundColor: "#1E3A8A", // deep ERP-blue
                            color: "#FFFFFF",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#33c9c9ff")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#0d5f5bff")}
                    >
                        {isLoading ? <CircularProgress size={20} color="inherit" /> : "Previous Revisions"}
                    </Button>

                    {/* Revision Create Button - Only show if not revised */}
                    {/* {formData.IsRevised !== true && ( */}
                    <Button
                        variant="contained"
                        // onClick={handleSubmit}
                        disabled={isLoading}
                        component={Link}
                        to={`/RevisionQuotationCreate/${formData.Id}`}
                        style={{
                            height: "25px",
                            minWidth: "80px",
                            borderRadius: "6px",
                            backgroundColor: "#1E3A8A", // deep ERP-blue
                            color: "#FFFFFF",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#1E3A8A")}
                    >
                        {isLoading ? <CircularProgress size={20} color="inherit" /> : "Revision"}
                    </Button>
                    {/* )}*/}

                    {/* Terms & Conditions Button */}
                    <>
                        {/* Terms & Conditions Button */}
                        <Button
                            variant="contained"
                            onClick={LoadTermsAndConditions}
                            style={{
                                height: "25px",
                                minWidth: "80px",
                                borderRadius: "6px",
                                backgroundColor: "#149a9eff",
                                color: "#FFFFFF",
                                fontWeight: 600,
                                fontSize: "13px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                textTransform: "none",
                                transition: "background-color 0.2s, box-shadow 0.2s",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#047074ff")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#149a9eff")}
                        >
                            {isLoading ? <CircularProgress size={20} color="inherit" /> : "T & C"}
                        </Button>

                        {/* ✅ Modal */}
                        {isModalGrpOpen && (
                            <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
                                <div
                                    className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto animate-zoomIn"
                                >
                                    {/* Header with Close Button */}
                                    <div className="flex justify-between items-center mb-4 border-b pb-2">
                                        <h6 className="uppercase tracking-wide font-serif text-black mt-2">
                                            Terms & Conditions
                                        </h6>
                                        <IconButton onClick={handleCloseModalTC}>
                                            <CloseIcon />
                                        </IconButton>
                                    </div>

                                    {/* Table Section */}
                                    <div
                                        className="w-full"
                                        style={{ maxHeight: "520px", overflowY: "auto", width: "100%", marginTop: '-15px' }}
                                    >
                                        <TableContainer
                                            component={Paper}
                                            sx={{
                                                maxHeight: 400, // 👈 set a fixed height to enable scrolling
                                                border: "1px solid #f4dfdf",
                                            }}
                                        >
                                            <Table stickyHeader>
                                                <TableHead>
                                                    <TableRow sx={{ backgroundColor: "#0f3460" }}>
                                                        {/* <TableCell sx={{ color: "white", fontWeight: "bold", padding: '3px', backgroundColor: "#071b33ff", fontSize: "12px" }}></TableCell> */}
                                                        <TableCell sx={{ color: "white", fontWeight: "bold", padding: '3px', backgroundColor: "#071b33ff", fontSize: "12px" }}>Sl.No</TableCell>
                                                        <TableCell sx={{ color: "white", fontWeight: "bold", padding: '3px', backgroundColor: "#071b33ff", fontSize: "12px" }}>Name</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {selectedTCItems && selectedTCItems.length > 0 ? (
                                                        selectedTCItems.map((item, index) => (
                                                            <TableRow
                                                                key={item.Id || index}
                                                                sx={{
                                                                    "&:hover": { backgroundColor: "#F1E7E7" },
                                                                    transition: "background-color 0.3s ease-in-out",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                {/* Serial No */}
                                                                <TableCell
                                                                    sx={{
                                                                        padding: "4px",
                                                                        borderRight: "1px solid #f4dfdf",
                                                                        fontSize: "12px",
                                                                        width: "10%",
                                                                    }}
                                                                >
                                                                    {index + 1}
                                                                </TableCell>

                                                                {/* Name */}
                                                                <TableCell
                                                                    sx={{
                                                                        padding: "4px",
                                                                        fontSize: "12px",
                                                                    }}
                                                                >
                                                                    {item.Name}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={3} align="center" sx={{ padding: "20px" }}>
                                                                {isLoading ? "Loading..." : "No terms found."}
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>

                    {formData.IsInvoiced == false && (
                        <Button
                            variant="contained"
                            component={Link}
                            to={`/QuotationEdit/${id}`}
                            className="linkcolor"
                            onClick={() => localStorage.setItem("shouldReload", "true")}
                            style={{
                                height: "25px",
                                minWidth: "90px",
                                borderRadius: "6px",
                                backgroundColor: "#ee7373ff", // light gray ERP style
                                color: "white",
                                fontWeight: 600,
                                fontSize: "13px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                textTransform: "none",
                                transition: "background-color 0.2s, box-shadow 0.2s",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#e04646ff")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#ee7373ff")}
                        >
                            Edit
                        </Button>
                    )}

                    {/* Back To List Button */}
                    <Button
                        variant="contained"
                        component={Link}
                        to="/QuotationIndex"
                        className="linkcolor"
                        onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{
                            height: "25px",
                            minWidth: "90px",
                            borderRadius: "6px",
                            backgroundColor: "#F3F4F6", // light gray ERP style
                            color: "#1E3A8A",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
                    >
                        Back To List
                    </Button>
                </div>
            </div>

            {/* <div className="grid grid-cols-12 gap-1 p-4 mb-3 rounded-lg bg-gray-100 -mt-2" style={{ marginTop: '-20px', background: '#F1F0E9' }}> */}
            <div
                style={{
                    display: "grid",
                    // gridTemplateColumns: "250px repeat(7, 1fr)", 
                    gridTemplateColumns: "repeat(9, 1fr)",
                    gap: "10px",
                    marginBottom: "12px",
                    alignItems: "end" // ✅ aligns all inputs properly
                }}
            >
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>QA Date</label>
                    <input
                        name="QuotationDate"
                        value={formatDate(formData.QuotationDate)}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600", color: 'red' }}>
                        QA No
                    </label>
                    <input
                        type="text"
                        name="QuotationNumber"
                        value={formData.QuotationNumber}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Amount</label>
                    <input
                        type="number"
                        name="Amount"
                        value={formData.Amount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Taxable Amount</label>
                    <input
                        type="number"
                        name="TaxableAmount"
                        value={formData.TaxableAmount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>CGST</label>
                    <input
                        type="number"
                        name="CGSTAmount"
                        value={formData.CGSTAmount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>SGST</label>
                    <input
                        type="number"
                        name="SGSTAmount"
                        value={formData.SGSTAmount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>IGST</label>
                    <input
                        type="number"
                        name="IGSTAmount"
                        value={formData.IGSTAmount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Round Off</label>
                    <input
                        type="number"
                        name="RoundOff"
                        value={formData.RoundOff}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Total Amount</label>
                    <input
                        type="number"
                        name="TotalAmount"
                        value={formData.TotalAmount}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                {/* ---------------- Row 3 - Bill Header Section ---------------- */}

                <div className="col-span-12 md:col-span-2">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Work Name</label>
                    <input
                        type="text"
                        name="WorkName"
                        value={formData.WorkName}
                        disabled
                        placeholder="Enter Work Name"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            backgroundColor: "#f5f5f5"
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-2">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Bill Header</label>
                    <input
                        type="text"
                        name="Description"
                        value={formData.Description}
                        disabled
                        placeholder="Enter Description"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            backgroundColor: "#f5f5f5"
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-2">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Remarks</label>
                    <input
                        type="text"
                        name="Remarks"
                        value={formData.Remarks}
                        disabled
                        placeholder="Enter Remarks"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            backgroundColor: "#f5f5f5"
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-1">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>HSN Code</label>
                    <input
                        type="text"
                        name="HSNCode"
                        value={formData.HSNCode || '-'}
                        disabled
                        placeholder="HSN"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            backgroundColor: "#f5f5f5"
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-1">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>UOM</label>
                    <input
                        type="text"
                        name="UOM"
                        value={formData.UOM || '-'}
                        disabled
                        placeholder="UOM"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            backgroundColor: "#f5f5f5"
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-1">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>GST %</label>
                    <input
                        type="text"
                        name="GSTRate"
                        value={formData.GSTRate || '-'}
                        disabled
                        placeholder="GST %"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            backgroundColor: "#f5f5f5"
                        }}
                    />
                </div>

            </div>

            {/* Grouped Table */}
            {
                Object.keys(filteredGroupedDataByQA).length > 0 && (
                    <div className="mb-2"
                        style={{
                            maxHeight: "430px",
                            overflowY: "auto",
                            overflowX: "auto",
                            marginBottom: "12px",
                            border: "1px solid #999",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            width: "100%",
                        }}>
                        {/* <TableContainer component={Paper}> */}
                        <table
                            style={{
                                minWidth: "1780px",
                                width: "100%",
                                borderCollapse: "collapse",
                                fontSize: "13px",
                                fontFamily: "monospace",
                                tableLayout: "fixed",
                            }}
                        >
                            <thead
                                style={{
                                    backgroundColor: "#1F2A38",
                                    color: "#FFFFFF",
                                    position: "sticky",
                                    top: 0, // ← must include top
                                    zIndex: 2, // ← ensures it stays above table body
                                }}
                            >
                                <TableRow>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '60px', minWidth: '60px', textAlign: 'left', position: 'sticky', left: '0', backgroundColor: '#1F2A38', zIndex: '3' }}>Sl.No</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '400px', minWidth: '400px', textAlign: 'left', position: 'sticky', left: '60px', backgroundColor: '#1F2A38', zIndex: '3' }}>Description</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '100px', minWidth: '100px', textAlign: 'left' }}>UOM</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '100px', minWidth: '100px', textAlign: 'center' }}>QTY</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>RATE</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>AMOUNT</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>TAXABLE</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>GST ₹</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>TOTAL</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '180px', minWidth: '180px', textAlign: 'left' }}>Remarks</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '180px', minWidth: '180px', textAlign: 'left' }}>Item Remark</TableCell>
                                </TableRow>
                            </thead>
                            <TableBody>
                                {Object.entries(filteredGroupedDataByQA).map(([qaName, workGroups], qaIndex) => (
                                    <React.Fragment key={qaIndex}>

                                        {/* Main QAChildDetailName Header */}
                                        <tr style={{ backgroundColor: "#D7D3BF", textAlign: 'center' }}>
                                            <td
                                                colSpan={11}
                                                style={{
                                                    fontWeight: "bold",
                                                    fontSize: "13px",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {qaName}
                                            </td>
                                        </tr>

                                        {/* WorkName Groups */}
                                        {
                                            Object.keys(workGroups).map((workName, groupIndex) => (
                                                <React.Fragment key={groupIndex}>
                                                    {/* WorkName Sub-header */}
                                                    <TableRow onClick={() => toggleGroup(`${qaName}-${workName}`)} style={{ cursor: 'pointer' }}>
                                                        <TableCell colSpan={11} style={{
                                                            backgroundColor: '#f0e8dfff',
                                                            color: 'black',
                                                            fontWeight: 'bold',
                                                            textTransform: 'uppercase',
                                                            fontSize: '12px',
                                                            padding: '4px',
                                                        }}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                <span>{workName}</span>
                                                                <span style={{ fontSize: '14px' }}>
                                                                    {expandedGroups[`${qaName}-${workName}`] ? '▲' : '▼'}
                                                                </span>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>

                                                    {/* Items */}
                                                    {expandedGroups[`${qaName}-${workName}`] &&
                                                        workGroups[workName].map((item, index) => (
                                                            <TableRow key={`${qaName}-${workName}-${index}`} style={{
                                                                backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                                                borderBottom: '1px solid #E0E0E0',
                                                            }}>
                                                                <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '2px', textAlign: 'left', width: '60px', position: 'sticky', left: '0', backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF', zIndex: '1' }}>
                                                                    {index + 1}
                                                                </td>
                                                                <td style={{ fontSize: '10.5px', padding: '3px', width: '400px', borderRight: '1px solid #E0E0E0', position: 'sticky', left: '60px', backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF', zIndex: '1' }}>
                                                                    {/* <span style={{ color: 'brown' }}>{item.WorkItemName}</span> /*/}
                                                                    <span style={{ color: 'blue' }}>{item.DetailsName}</span> / {item.WorkDetailsName}
                                                                </td>
                                                                <td style={{ fontSize: '11px', fontWeight: 'bold', padding: '3px', width: '5%' }}>{item.UOM}</td>
                                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                                    <input type="number" value={item.Quantity} disabled style={{ width: "100%", textAlign: "right", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                                </td>
                                                                <td style={{ padding: '3px', textAlign: 'right', width: '70px' }}>
                                                                    <input type="number" value={item.Rate || 0} disabled style={{ width: "100%", textAlign: "right", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                                </td>
                                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                                    <input type="number" value={item.Amount || 0} disabled style={{ width: "100%", textAlign: "right", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                                </td>
                                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                                    <input type="number" value={item.TaxableAmount || 0} disabled style={{ width: "100%", textAlign: "right", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                                </td>
                                                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                                                    <input
                                                                        value={parseFloat(item.CGSTAmount) + parseFloat(item.SGSTAmount) + parseFloat(item.IGSTAmount)}
                                                                        readOnly
                                                                        style={{ width: "70%", textAlign: "right", border: "1px solid #ccc", borderRadius: "3px", padding: "2px" }}
                                                                    />
                                                                    <span style={{ marginLeft: "4px", color: "darkmagenta", fontSize: "11px" }}>
                                                                        {item.GSTRate ? parseFloat(item.GSTRate) : 0}%
                                                                    </span>
                                                                </td>
                                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                                    <input type="number" value={item.TotalAmount || 0} disabled style={{ width: "100%", textAlign: "right", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} />
                                                                </td>
                                                                <td style={{ fontSize: '11px', fontWeight: 'bold', padding: '3px', width: '180px', borderRight: '1px solid #E0E0E0', }}>
                                                                    <textarea value={item.Remarks || ""} style={{ width: "100%", textAlign: "left", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} readOnly />
                                                                </td>
                                                                <td style={{ fontSize: '11px', fontWeight: 'bold', padding: '3px', width: '180px', borderRight: '1px solid #E0E0E0', }}>
                                                                    <textarea value={item.ItemRemark || ""} style={{ width: "100%", textAlign: "left", border: "1px solid #bbb", borderRadius: "3px", padding: "2px" }} readOnly />
                                                                </td>
                                                            </TableRow>
                                                        ))}
                                                </React.Fragment>
                                            ))
                                        }
                                    </React.Fragment>
                                ))}
                            </TableBody>

                        </table>
                        {/* </TableContainer> */}
                    </div>


                )
            }

            {
                isModalOpen && (
                    <div
                        className="fixed inset-0 flex items-center justify-center z-50 bg-black/30"
                    >
                        <div
                            className="bg-white rounded-lg shadow-lg relative w-full max-w-4xl mx-4"
                            style={{ maxHeight: '90vh', overflowY: 'auto' }}
                        >
                            {/* Close Button */}
                            <Tooltip title="Close Previous Revision">
                                <IconButton
                                    onClick={() => setIsModalOpen(false)}
                                    sx={{ position: 'absolute', top: 10, right: 10, zIndex: 20 }}
                                    size="small"
                                    aria-label="close"
                                >
                                    <CloseIcon fontSize="small" sx={{ color: 'darkred' }} />
                                </IconButton>
                            </Tooltip>

                            {/* Modal Title */}
                            <h6
                                className="text-center font-bold uppercase"
                                style={{ color: '#4C063C', fontSize: '13px', marginTop: '10px' }}
                            >
                                Previous Revision
                            </h6>

                            {/* Header Info */}
                            <div className="p-3 rounded-lg shadow-sm bg-white border border-gray-200 mb-3">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-sm">
                                    <p>
                                        <span className="font-semibold text-gray-700">QA No: </span>
                                        <span className="text-gray-900">{formData?.QuotationNumber || "-"}</span>
                                    </p>
                                    <p>
                                        <span className="font-semibold text-gray-700">Customer: </span>
                                        <span className="text-gray-900">{formData?.CustomerName || "-"}</span>
                                    </p>
                                    <p>
                                        <span className="font-semibold text-gray-700">GST No: </span>
                                        <span className="text-gray-900">{formData?.GSTNumber || "-"}</span>
                                    </p>
                                </div>
                            </div>

                            {/* Table */}
                            <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {[
                                                "Sl.No",
                                                "QA Date",
                                                "QA Rev No",
                                                "Taxable(₹)",
                                                "CGST(₹)",
                                                "SGST(₹)",
                                                "IGST(₹)",
                                                "Total(₹)",
                                                ""
                                            ].map((header, index) => (
                                                <TableCell
                                                    key={index}
                                                    style={{
                                                        backgroundColor: "#1F1F1F", // dark header
                                                        color: "#FFFFFF",           // white text
                                                        fontWeight: 600,
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 10,
                                                        whiteSpace: "nowrap",
                                                        padding: "4px",
                                                        textTransform: "uppercase",
                                                    }}
                                                >
                                                    {header}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Array.isArray(revisionData) && revisionData.length > 0 ? (
                                            revisionData.map((item, index) => (
                                                <TableRow
                                                    key={item.Id}
                                                    sx={{
                                                        "&:hover": { backgroundColor: "#F1F1F1" },
                                                        transition: "background-color 0.3s ease-in-out",
                                                    }}
                                                >
                                                    <TableCell sx={{ padding: "4px", textAlign: "center" }}>{index + 1}</TableCell>
                                                    <TableCell sx={{ padding: "4px", textAlign: "left" }}>
                                                        {item.QuotationDate ? formatDate(item.QuotationDate) : "-"}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: "4px", textAlign: "left" }}>
                                                        <Link
                                                            to={`/QuotationRevisionDetails/${item.Id}`}
                                                            style={{ color: "#27445D", fontWeight: "bolder" }}
                                                        >
                                                            {item.RevisionNumber}
                                                        </Link>
                                                    </TableCell>
                                                    <TableCell sx={{ padding: "4px", textAlign: "right" }}>{item.TaxableAmount?.toFixed(2) || "0.00"}</TableCell>
                                                    <TableCell sx={{ padding: "4px", textAlign: "right" }}>{item.CGSTAmount?.toFixed(2) || "0.00"}</TableCell>
                                                    <TableCell sx={{ padding: "4px", textAlign: "right" }}>{item.SGSTAmount?.toFixed(2) || "0.00"}</TableCell>
                                                    <TableCell sx={{ padding: "4px", textAlign: "right" }}>{item.IGSTAmount?.toFixed(2) || "0.00"}</TableCell>
                                                    <TableCell sx={{ padding: "4px", textAlign: "right" }}>{item.TotalAmount?.toFixed(2) || "0.00"}</TableCell>
                                                    <TableCell sx={{ padding: "4px", textAlign: "center" }}>
                                                        {/* <Tooltip title="Quotation Print" arrow>
                                                        <IconButton size="small" onClick={() => handlePrint(item.Id)}>
                                                            <PrintIcon sx={{ fontSize: 18, color: "darkmagenta" }} />
                                                        </IconButton>
                                                    </Tooltip> */}
                                                        <Tooltip title="Quotation Print" arrow>
                                                            <IconButton size="small" onClick={() => handleGenerateRevision(item.Id)}>
                                                                <PrintIcon sx={{ fontSize: 18, color: 'darkmagenta' }} />
                                                            </IconButton>
                                                        </Tooltip>

                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={9} sx={{ textAlign: "center", padding: "16px", fontStyle: "italic" }}>
                                                    No previous data found
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </div>
                    </div>
                )
            }

        </div >
    );
};

export default QuotationDetails;
